export default __webpack_public_path__ + "8227d37f1d3eddf062763191ddb2b061.jpg";